import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { URL_APPSTORE_APPLE, URL_APPSTORE_GOOGLE } from 'constants/web-app-constants';

@Component({
  selector: 'web-components-app-info',
  templateUrl: './app-info.component.html',
  styleUrls: ['../login-info-cards.component.scss'],
  imports: [TranslocoPipe],
})
export class AppInfoComponent {
  public readonly URL_APPSTORE_APPLE = URL_APPSTORE_APPLE;
  public readonly URL_APPSTORE_GOOGLE = URL_APPSTORE_GOOGLE;
}
